document.addEventListener('DOMContentLoaded', function() {
  const accordionItems = document.querySelectorAll('.size-care-accordion-item');
  
  accordionItems.forEach(function(item) {
    const button = item.querySelector('.size-care-accordion-title');
    const content = item.querySelector('.size-care-accordion-content');
    const plusIcon = item.querySelector('.accordion-icon-plus');
    const minusIcon = item.querySelector('.accordion-icon-minus');
    
    button.addEventListener('click', function() {
      const isOpen = content.style.display !== 'none';
      
      if (isOpen) {
        content.style.display = 'none';
        plusIcon.style.display = 'block';
        minusIcon.style.display = 'none';
        item.classList.remove('is-active');
      } else {
        content.style.display = 'block';
        plusIcon.style.display = 'none';
        minusIcon.style.display = 'block';
        item.classList.add('is-active');
        
        setTimeout(function() {
          window.dispatchEvent(new Event('resize'));
          if (typeof window.KiwiSizing !== 'undefined' && window.KiwiSizing.init) {
            window.KiwiSizing.init();
          }
        }, 100);
      }
    });
  });
  
  if (accordionItems.length > 0) {
    const firstItem = accordionItems[0];
    const firstButton = firstItem.querySelector('.size-care-accordion-title');
    firstButton.click();
  }
});

